<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">
			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">{{ $t('opco.title') }}</h4>
					<p class="mb-0">
						{{ $t('opco.description') }}
					</p>
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4">
					<button class="btn btn-primary waves-effect waves-light" type="button" disabled="" v-if="isDownloading">
						<span class="spinner-border me-1" role="status" aria-hidden="true"></span>
						{{ $t('common.loading') }}
					</button>
				</div>
			</div>

			<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
				<span class="visually-hidden">{{ $t('common.loading') }}</span>
			</div>

			<div class="col-lg-12" v-if="!isLoading">
				<div class="card h-100">
					<div class="table-responsive">
						<table class="table table-borderless">
							<thead>
								<tr class="border-bottom">
									<th class="bg-transparent fs-xsmall">{{ $t('opco.trainee') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('opco.training') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('common.fields.status') }}</th>
									<th class="bg-transparent fs-xsmall">{{ $t('common.fields.actions') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(month, index) in months" :key="index">
									<td>
										<div class="d-flex justify-content-start align-items-center">
											<div class="avatar avatar me-4">
												<span class="avatar-initial rounded-circle bg-label-primary" v-if="month.isReady">
													<i class="ri-folder-line"></i>
												</span>
												<span class="avatar-initial rounded-circle bg-label-warning" v-else>
													<i class="ri-hourglass-line"></i>
												</span>
											</div>
											<div>
												<h6 class="mb-0 text-truncate">{{ month.month }}</h6>
											</div>
										</div>
									</td>
									<td>
										{{ $t('opco.completedTrainings', { count: month.totalCount }) }}
									</td>
									<td>
										<span :class="getStatusInfo(month).class">
											{{ getStatusInfo(month).text }}
										</span>
									</td>
									<td>
										<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="downloadFolder(month)" data-bs-toggle="tooltip" :data-bs-title="$t('opco.downloadFolder')" v-if="!month.isLoading">
											<i class="ri-download-2-line ri-22px"></i>
										</a>

										<div class="spinner-border spinner-border text-primary month-loader" role="status" v-if="month.isLoading">
										</div>

										<!-- <a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="markAsSent(trainee._id)" data-bs-toggle="tooltip" title="Marqué comme envoyé aux OPCO">
											<i class="ri-mail-send-line"></i>
										</a> -->
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

moment.locale(localStorage.getItem('locale') || 'fr');

import { Tooltip } from 'bootstrap'

export default {
	name: "ConventionPages",

	data() {
		return {
			isLoading: true,
			isDownloading: false,
			months: [],
		};
	},

	methods: {
		getStatusInfo(month) {
			if (month.isReady) {
				return {
					text: this.$t('opco.folderReady'),
					class: 'badge bg-label-primary rounded-pill'
				};
			}
			else {
				return {
					text: this.$t('opco.folderPreparing'),
					class: 'badge alert-warning rounded-pill'
				};
			}
		},

		async fetchMonths() {
			try {
				// Appel API avec les filtres et pagination
				const response = await HTTP.get("/opco/months");

				// Mise à jour des données
				this.months = response.data.months;
				this.isLoading = false;

				setTimeout(() => {
					const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
					tooltipTriggerList.forEach((el) => {
						new Tooltip(el)
					})
				}, 100)
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async downloadFolder(month) {
			try {
				month.isLoading = true;

				// Appel API pour récupérer le PDF en base64
				const response = await HTTP.post(`/opco/download`, { month: month.slug });

				// Télécharger le fichier depuis l'URL signée
				const link = document.createElement('a');
				link.href = response.data.downloadUrl;
				link.download = `export-${month.slug}.zip`; // Nom du fichier suggéré
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				month.isLoading = false;
			} catch (error) {
				month.isLoading = false;

				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || 
					this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		formatDate(date) {
			return moment(date).format("DD/MM/YYYY"); // Affiche "il y a 3 semaines"
		},

		formatRelativeDate(date) {
			return moment(date).fromNow(); // Affiche "il y a 3 semaines"
		},
	},

	async mounted() {
		this.fetchMonths();
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.load-center {
	display: block;
	margin: 0 auto;
}

.month-loader {
	width: 20px;
	height: 20px;
	margin-left: 8px;
}
</style>
